export default __webpack_public_path__ + "static/media/dropdown-icon.2790f54f.svg";